import { render, staticRenderFns } from "./VChristmasTreeLoader.vue?vue&type=template&id=32d58a8e"
import script from "./VChristmasTreeLoader.vue?vue&type=script&lang=js"
export * from "./VChristmasTreeLoader.vue?vue&type=script&lang=js"
import style0 from "./VChristmasTreeLoader.vue?vue&type=style&index=0&id=32d58a8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports